var exports = {
  "az": "Box__rbnwRR",
  "EY": "Text__GFNO1W",
  "wy": "Box_1__kWUryh",
  "UE": "Text_1__f-kMog",
};

module.exports = exports;
